import { Box, FormControl, InputLabel, Typography, useTheme } from '@mui/material';
import { usePasswordReset } from '_api';
import { InitialRouteMap } from '_constants';
import { SEVERITY } from '_constants/derived';
import { PrimaryButton, StyledOutlinedInput, TextButton } from 'components/atoms';
import { AlertMessage } from 'components/molecules';
import React, { ChangeEvent, useState } from 'react';
import { useNavigateTo } from 'utils';

import { LoginPaper } from './styles';
import { ResetPasswordProps } from './types';

export const ResetPassword = ({ confirmationCode }: ResetPasswordProps) => {
  const theme = useTheme();
  const navigate = useNavigateTo();
  const { mutateAsync: ResetPassword } = usePasswordReset();
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const toLogin = () => navigate(InitialRouteMap.LOGIN);

  const handleNewPasswordChange = ({
    target: { value: newValue },
  }: ChangeEvent<HTMLInputElement>) => {
    setNewPassword(newValue);
  };

  const handleNewPasswordConfirmationChange = ({
    target: { value: newValue },
  }: ChangeEvent<HTMLInputElement>) => {
    setNewPasswordConfirmation(newValue);
  };

  const sendReset = () => {
    ResetPassword({ confirmationCode, newPassword, newPasswordConfirmation })
      .then(() => {
        setShowSuccess(true);
      })
      .catch((err: any) => {
        setErrorMessage(err.message);
      });
  };

  return (
    <LoginPaper>
      <img src="/img/logo-sign-in.png" alt={''} style={{ maxWidth: '20%' }} />
      {!showSuccess ? (
        <>
          <FormControl required={true} style={{ width: '100%' }}>
            <StyledOutlinedInput type="password" onChange={handleNewPasswordChange} />
            <InputLabel sx={{ background: theme.palette.background.paper }}>
              New Password
            </InputLabel>
          </FormControl>
          <FormControl required={true} style={{ width: '100%' }}>
            <StyledOutlinedInput
              type="password"
              onChange={handleNewPasswordConfirmationChange}
            />
            <InputLabel sx={{ background: theme.palette.background.paper }}>
              Confirm Password
            </InputLabel>
          </FormControl>
          <PrimaryButton onClick={sendReset} sx={{ width: '100%' }}>
            SUBMIT PASSWORD RESET
          </PrimaryButton>
          <TextButton onClick={toLogin} sx={{ width: '100%' }}>
            RETURN TO SIGN IN
          </TextButton>
        </>
      ) : (
        <>
          <Box sx={{ margin: 'auto', marginBottom: '10px', textAlign: 'center' }}>
            <Typography variant="body1">Password successfully reset.</Typography>
            <Typography variant="body1">Return to sign in view to log in.</Typography>
          </Box>
          <PrimaryButton onClick={toLogin} sx={{ width: '100%' }}>
            RETURN TO SIGN IN
          </PrimaryButton>
        </>
      )}
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={
          <>
            Failed to reset password.
            <br />
            {errorMessage}
            <br />
            Please Try again
          </>
        }
      />
    </LoginPaper>
  );
};
